
















import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import { Action, Getter, Mutation } from 'vuex-class';
import {App, Application, AppVersion, Organisation} from '../types';
import Table from '@/components/Table.vue';
import AppsService from '@/services/apps.service';


@Component({
  components: {
    Table,
    SearchBar,
  },
})
export default class AppsList extends Vue {
  public selectedApplication: Application | null = null;
  private applications: any[] = [];
  @Prop() private editApplication: any;
  @Prop({default: null}) private searchNames!: string;
  private tableData: any = {
    headers: [
      {
        text: 'Application',
        value: 'name',
        querySortKey: 'name',
      },
      {
        text: 'Publisher',
        value: 'publisher',
        querySortKey: 'publisher',
      },
      {
        text: 'Description',
        value: 'description',
      },
      {
        text: 'Version',
        value: 'version',
      },
    ],
    rows: [],
    total: 0,
    filters: {},
  };
  private loading: boolean = false;

  public async loadApplications() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    try {
      const apps = await AppsService.getApplications();

      this.applications = apps.flatMap((app: App) =>
        app.versions.map((av: AppVersion) => ({
          ...app,
          version: av.version,
          itemKey: `${app.id}-${av.version}`,
        })),
      );

      Vue.set(
        this.tableData,
        'rows',
        this.applications,
      );
    } finally {
      this.loading = false;
    }
  }

  private async mounted() {
    await this.loadApplications();
  }
}
